import styled, { css } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import _ from 'lodash';
import Icon from 'components/Icon';
import {
  socialsColor,
  socialsActiveColor,
  socialsHoverColor,
} from 'theme/variables';
import base from './base';

export const RouterLinkStyled = styled(RouterLink)`
  ${base};

  ${(props) =>
    props.type === 'social' &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 40px;
      width: 42px;
      border-radius: 3px;
      cursor: pointer;
    `};

  ${(props) =>
    props.icon &&
    css`
      background-color: ${_.get(socialsColor, props.icon, null)};

      &:hover {
        background-color: ${_.get(socialsHoverColor, props.icon, null)};
      }
      &:active {
        background-color: ${_.get(socialsActiveColor, props.icon, null)};
      }
    `};
`;

export const LinkStyled = styled.a`
  ${base};

  ${(props) =>
    props.type === 'social' &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 40px;
      width: 42px;
      border-radius: 3px;
      cursor: pointer;
    `};

  ${(props) =>
    props.icon &&
    css`
      background-color: ${_.get(socialsColor, props.icon, null)};

      &:hover {
        background-color: ${_.get(socialsHoverColor, props.icon, null)};
      }
      &:active {
        background-color: ${_.get(socialsActiveColor, props.icon, null)};
      }
    `};
`;

export const StyledIcon = styled(Icon)`
  cursor: pointer;
`;
